import { render } from "./CartLikePriceDetail.vue?vue&type=template&id=d380eef2&scoped=true"
import script from "./CartLikePriceDetail.js?vue&type=script&lang=js"
export * from "./CartLikePriceDetail.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=d380eef2&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CartLikePriceDetail.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FCartDetail%2FCartLikePriceDetail%2FCartLikePriceDetail.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d380eef2"]])

export default __exports__